// Public landing page for the LinkedIn OAuth popup.
//
// LinkedIn redirects here with ?code/?state (or ?error). The web popup relays
// the result to its opener via postMessage. Native Connect uses the same
// registered redirect URI, so when there is no opener we bounce into the app
// scheme and the app exchanges the code.

import { useEffect } from 'react';
import { Linkedin } from 'lucide-react';
import { linkedInAppCallbackUrl } from '../hooks/linkedinNative';

export default function LinkedInCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code') || undefined;
    const state = params.get('state') || undefined;
    const error = params.get('error') || params.get('error_description') || undefined;

    const payload = error
      ? { type: 'linkedin-oauth' as const, error }
      : { type: 'linkedin-oauth' as const, code, state };

    if (window.opener) {
      window.opener.postMessage(payload, window.location.origin);
      window.close();
      return;
    }

    if (state) {
      window.location.replace(linkedInAppCallbackUrl({ state, code, error }));
    }
  }, []);

  return (
    <div className="min-h-screen bg-off-white flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-sm p-8 text-center max-w-sm">
        <Linkedin size={28} className="text-[#0a66c2] mx-auto mb-3" />
        <p className="text-sm text-gray-600">Returning to Iron Forums…</p>
      </div>
    </div>
  );
}
